<template>
  <div class="row">
    <div v-if="customer" class="col-12">
      <Heading>
        {{ customer.name }}
      </Heading>
      <div class="border border-light p-5">

        <div class="row">

          <div class="col-4">
            <b class="text-primary">Standort:</b><br>
            <data-input v-model.trim="customer.address"/>
            <div class="row">
              <div class="col pr-1">
                <data-input v-model.trim="customer.postal"/>
              </div>
              <div class="col-7 pl-0">
                <data-input v-model.trim="customer.city"/>
              </div>
            </div>
          </div>
          <div class="col-4">
            <b class="text-primary">Telefonnummer:</b><br>

            <data-input type="tel"
                        placeholder="Telefonnummer"
                        v-model.trim="customer.phone"
            />
          </div>
          <div class="col-4">
            <b class="text-primary">E-Mail Adresse:</b><br>
            <data-input type="email"
                        placeholder="E-Mail Adresse"
                        v-model.trim="customer.email"
            />
          </div>

          <div class="col-3 offset-6 text-right">
            <button @click="cancel" class="btn btn-secondary btn-block mt-5 btn-sm">Abbrechen</button>
          </div>
          <div class="col-3 text-right">
            <button @click="save" class="btn btn-primary btn-block mt-5 btn-sm">Speichern</button>
          </div>
        </div>
      </div>
      <list :items="customer.bottles" class="mt-5">
        <template v-slot:header>
          <div class="row">
            <div class="col-4">Flaschen Nummer</div>
            <div class="col-4">Typ</div>
            <div class="col-3">Fällig am</div>
          </div>
        </template>
        <template v-slot:itemTemplate="{item}">
          <div class="row align-items-center py-1">
            <!--						 <div class="col-12">{{item}}</div>-->
            <div class="col-4">
              Nr. {{ item.serial }}
            </div>
            <div class="col-4">
              {{ item.type }}
            </div>
            <div class="col-3">
              {{ dateWithFormat(item.due) }}
            </div>
            <div class="col-1">
              <button class="btn" @click="$router.push('/admin/bottles/'+item.id)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </template>
      </list>
    </div>
  </div>
</template>

<script>
import Heading from "../../components/admin/Heading";
import {mapActions} from "vuex";
import BottleState from "../../components/admin/BottleState";
import List from "../../components/admin/List";
import timeFormatter from "../../mixins/timeFormatter";
import DataSelect from "../../components/DataSelect";
import DataInput from "../../components/DataInput";

export default {
  name: "CustomerDetail",
  components: {DataInput, DataSelect, Heading, BottleState, List},
  mixins: [timeFormatter],
  data() {
    return {
      customer: null
    }
  },
  mounted() {
    this.fetchCustomerDetails({id: this.$route.params.customer_id})
        .then(res => this.customer = res)
        .catch(this.apiErrorHandler)
  },
  methods: {
    ...mapActions({
      fetchCustomerDetails: "Api/Customers/get",
      modifyCustomerDetails: "Api/Customers/modify"
    }),
    save() {
      this.modifyCustomerDetails(this.customer)
          .then(result => this.$router.back())
          .catch(this.apiErrorHandler)
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>
